import { render, staticRenderFns } from "./TipoTributacaoView.vue?vue&type=template&id=1bc0bfe6"
import script from "./TipoTributacaoView.vue?vue&type=script&lang=js"
export * from "./TipoTributacaoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports